import {useEffect} from 'react'
import {AnalyticsHandler} from '../shared/handlers/analytics/handlers'

// Custom hook for analytics page load tracking
export const useAnalyticsPageLoad = (pageName) => {
  const clientId = sessionStorage.getItem('clientId')

  useEffect(() => {
    if (clientId) {
      AnalyticsHandler.onPageLoad({pageName})
    }
  }, [pageName, clientId])
}
